import React, { useRef, useState } from "react";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Clear";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { Button } from "@mui/material";

interface AvatarUploadProps {
  logoText?: string;
  photoUrl?: string;
  onSubmit: (file: File) => void;
  onRemove: () => void;
}

export const AvatarUpload: React.FC<AvatarUploadProps> = ({
  logoText = "IMAGE",
  photoUrl,
  onSubmit,
  onRemove,
}) => {
  // const [imageSrc, setImageSrc] = useState<string | undefined>(photoUrl);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;

    if (file) {
      // Check if the file size is greater than 3MB
      if (file.size > 3 * 1024 * 1024) {
        enqueueSnackbar(
          "File size exceeds 3MB. Please select a smaller file.",
          {
            variant: "error",
            key: "file-size",
            action: (key) => (
              <Button onClick={() => closeSnackbar(key)}>Dismiss</Button>
            ),
          }
        );
        return;
      }

      onSubmit(file);
    }
  };

  const handleRemoveClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset the file input
    }
    onRemove();
  };

  const handleAvatarClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        textAlign: "center",
        padding: "1rem",
      }}
    >
      <Avatar
        src={photoUrl || ""}
        sx={{ width: 150, height: 150 }}
        onClick={handleAvatarClick}
      >
        {photoUrl ? null : logoText}
      </Avatar>
      {photoUrl && (
        <IconButton
          aria-label="delete"
          onClick={handleRemoveClick}
          style={{ position: "absolute", top: 0, right: 0 }}
        >
          <CancelIcon />
        </IconButton>
      )}
      <input
        type="file"
        accept=".png, .jpg, .jpeg" // Allow only PNG and JPG/JPEG files
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleImageChange}
      />
    </div>
  );
};

export default AvatarUpload;
